<template>
  <v-card class="mb-2">
    <v-card-title> Reciever Information </v-card-title>
    <table style="width: 100%">
      <tr>
        <td>Reciever Name</td>
        <td>
          <span class="font-weight-bold">{{
            recieverInfo.first_name
              ? recieverInfo.first_name +
                " " +
                recieverInfo.middle_name +
                " " +
                recieverInfo.last_name
              : null
          }}</span>
        </td>
        <td>Reciever ID</td>
        <td>
          <span class="font-weight-bold">{{
            recieverInfo.receiver_id ? recieverInfo.receiver_id : null
          }}</span>
        </td>
      </tr>

      <tr>
        <td>User Type</td>
        <td class="font-weight-bold">
          {{
            recieverInfo.user_type && recieverInfo.user_type === "IND"
              ? "Individual"
              : recieverInfo.user_type && recieverInfo.user_type === "BUS"
              ? "Business"
              : null
          }}
        </td>
        <td>Address</td>
        <td class="font-weight-bold">
          <span>{{ recieverInfo.address ? recieverInfo.address : null }}</span>
        </td>
      </tr>

      <tr>
        <td>Mobile Number</td>
        <td class="font-weight-bold">
          <span class="font-weight-bold">{{
            recieverInfo.mobile ? recieverInfo.mobile : null
          }}</span>
        </td>
        <td>DOB</td>
        <td class="font-weight-bold">
          <span>
            {{ recieverInfo.dob ? recieverInfo.dob : null }}
          </span>
        </td>
      </tr>
      <tr>
        <!-- <td>Issue Country</td>
        <td>{{ recieverInfo.name ? recieverInfo.name : null }}</td> -->
        <td>Email</td>
        <td class="font-weight-bold">
          <span>{{ recieverInfo.email ? recieverInfo.email : null }}</span>
        </td>
        <td>Location Name</td>
        <td class="font-weight-bold">
          <span>
            {{ recieverInfo.location_name ? recieverInfo.location_name : null }}
          </span>
        </td>
      </tr>
      <tr>
        <td>Branch</td>
        <td class="font-weight-bold">
          <span>
            {{ recieverInfo.branch ? recieverInfo.branch : null }}
          </span>
        </td>
        <td>Account Number</td>
        <td class="font-weight-bold">
          <span>
            {{ recieverInfo.ac_number ? recieverInfo.ac_number : null }}
          </span>
        </td>
      </tr>
      <tr>
        <td>Relationship</td>
        <td class="font-weight-bold">
          <span>
            {{
              recieverInfo.relationship ? recieverInfo.relationship.value : null
            }}
          </span>
        </td>
      </tr>
    </table>
    <!-- <div class="text-center">
      <v-dialog persistent v-model="editRecieverDialog" width="900px">
        <RecieverInfoEditVue
          @RecieverDataUpdated="RecieverDataUpdated"
          @closeDialog="closeDialog"
          :recieverInfo="recieverInfo"
        />
      </v-dialog>
    </div> -->
  </v-card>
</template>

<script>
// import RecieverInfoEditVue from "./EditTxnDetails/RecieverInfoEdit.vue";
export default {
  data() {
    return {
      editRecieverDialog: false,
    };
  },
  components: {
    // RecieverInfoEditVue,
  },

  props: {
    recieverInfo: {
      type: Object,
    },
  },
  methods: {
    closeDialog() {
      this.editRecieverDialog = false;
    },
    RecieverDataUpdated() {
      this.$emit("RecieverDataUpdated");
    },
  },
};
</script>

<style lang="scss" scoped>
th,
td {
  border-bottom: 1px solid rgb(231, 229, 229);
  border-collapse: collapse;
  padding: 5px;
}
</style>
